import { Injectable } from '@angular/core';
import { AuthorizationFrontendService, ConfigurationFrontendService } from '@numen/smex-lib-common-frontend';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  
  private apiUri = this.configurationService.getBackendApiUri('cfnecm');

  constructor(
    private authorizationService: AuthorizationFrontendService,
    private configurationService: ConfigurationFrontendService,
  ) { }
  
  async updateUserPassword({currentPassword, newPassword, checkPassword}: {currentPassword: string, newPassword: string, checkPassword: string}) {
    try {
      const res = await this.authorizationService.put<{success: boolean}>(this.apiUri + '/account/password', {currentPassword, newPassword, checkPassword});
      return res.success;
    } catch (e: unknown) {
      return false;
    }
  }
}
